import { environment } from 'environments/environment';
import { ConstantsService } from 'app/services/constants-service';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, OnInit, Input, OnChanges, ViewContainerRef } from '@angular/core';

import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { relationsNamed } from 'app/entities/relations/relation-list.util';
import { EntityRelation } from 'app/shared/models/entity-relation.model';

import { EditRelationshipComponent } from 'app/entities/relations/editrelationship/edit-relationship.component';

@Component({
  selector: 'reverse-relationship',
  templateUrl: './reverse-relationship.component.html',
  styleUrls: ['./reverse-relationship.component.css']
})

/**
 * Component for reverse relationship.
 *
 * @author raj.sharma@vernuso.com (Raj Sharma)
*/
export class ReverseRelationshipComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  id: number;
  expend: any;
  reverseRelationshipDetails: EntityRelation[];
  dialogRef: MdDialogRef<any>;
  enableExecutiveSummary = environment.enableExecutiveSummary;
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;
  searchFilter = '';

  constructor(
    private entityRelationsService: EntityRelationsService,
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit() {
    this.ngOnChanges();
    this.entityRelationsService.currentMessage.subscribe(message => {
      if (message === 'updateRelationships') {
        this.ngOnChanges();
      }
    });
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.entityRelationsService.loadReverseRelationshipDetails(this.entityIdDetails.entityId).subscribe(
        response => {
          this.reverseRelationshipDetails = response.arrResult;
        });

      this.id = (this.entityIdDetails.entityType === EntityType.PERSON)
        ? this.entityIdDetails.personId
        : this.entityIdDetails.orgId;
    }
  }

  openEditReverseRelationDialog(relation: EntityRelation, commentType: string, text) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(EditRelationshipComponent, config);
    this.dialogRef.componentInstance.comment = text;
    this.dialogRef.componentInstance.relation = relation;
    this.dialogRef.componentInstance.commentType = commentType;
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnChanges();
      }
    });
  }

  onRelationSearch(value: string) {
    this.searchFilter = (value || '').trim().toLowerCase();
  }

  get visibleRelationships(): EntityRelation[] {
    return relationsNamed(this.reverseRelationshipDetails, this.searchFilter);
  }

  showDetail(i) {
    if (this.expend == i) {
      this.expend = null;
    } else {
      this.expend = i;
    }
  }

  isPersonOrOrganisation(relation) {
    return relation.entityType === 'PERSON'
      || relation.entityType === 'ORGANISATION';
  }

  isClient(relation) {
    return relation.entityType === 'CLIENT';
  }

  isUBOOrPEP(relation) {
    return relation.entityType === 'PERSON' && (relation.ubo || relation.pep);
  }

  getOriginOfFundsLabel(relation) {
    return this.isUBOOrPEP(relation) ? 'Source of Wealth' : 'Origin of Funds';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/reverse-relationship/reverse-relationship.component.ts